import { z } from "zod";
const createStringSchema = (fieldName: string) =>
  z
    .string({
      invalid_type_error: `${fieldName} must be a string`,
      required_error: `${fieldName} is required`,
    })
    .min(2, `${fieldName} is required`);

export const formSchema = z.object({
  firstName: createStringSchema("First Name").max(50),
  lastName: createStringSchema("Last Name").max(50),
  message: createStringSchema("Message").max(50),
  email: z.string().email("Invalid email address"),
  terms: z.boolean().refine((val) => val === true, {
    message: "You must agree to the terms and conditions",
  }),
  phoneNumber: z
    .string()
    .nonempty("Phone number is required")
    .regex(/^\+?[1-9]\d{1,14}$/, "Invalid phone number"),
});

export const loginWithEmailSchema = z.object({
  email: z.string().email("Invalid email address"),
  password: z.string().min(6, "Password is Required").max(50),
});

export const forgetPasswordSchema = z.object({
  email: z.string().email("Invalid email address"),
});

export const resetPasswordSchema = z.object({
  newPassword: z.string().min(8, "Password Must be 8 characters").max(50),
  confirmPassword: z.string().min(8, "Password Must be 8 characters").max(50),
});

export const registerWithEmailSchema = z.object({
  email: z.string().email("Invalid email address"),
  password: z.string().min(8, "Min 8 character password is required").max(50),
});

export type ResetPassFormValues = z.infer<typeof resetPasswordSchema>;
export type ForgetPasswordValues = z.infer<typeof forgetPasswordSchema>;
export type LoginFormValues = z.infer<typeof loginWithEmailSchema>;
export type RegisterFormValues = z.infer<typeof registerWithEmailSchema>;
export type FormValues = z.infer<typeof formSchema>;
